import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import "./Section3DAnimationNew.css";
import "../../../GalleryShared.css";
import { notifyPlaying, useVideoCoordinator } from "../../../../../utils/videoCoordinator";

//  3D Animation New Data
import YobykeMaterTrailerThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/automobile/_master_FullTrailer_thumbnail.webp";
import YobykeMaterTrailer    from "../../../../../Assets/Images/gallary/3d animation new/automobile/_master_FullTrailer_v001_LR.mp4";
import BillboardThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/automobile/Master.webp";
import Billboard    from "../../../../../Assets/Images/gallary/3d animation new/automobile/3D Billboard Ad_Eilan_20250705_004_V004.mp4";
import Ape_Teaser_LR    from "../../../../../Assets/Images/gallary/3d animation new/automobile/Ape Teaser_LR.mp4";
import Ape_Teaser_LR_Banner   from "../../../../../Assets/Images/gallary/3d animation new/automobile/Ape Teaser_LR (0-00-03-04).webp";
import DriftDX_Showcase_Wide    from "../../../../../Assets/Images/gallary/3d animation new/automobile/20231209_DriftDX+_Showcase_Wide version_lr.mp4";
import drift_dx_thumbnail   from "../../../../../Assets/Images/gallary/3d animation new/automobile/drift dx_thumbnail.webp";
import DDEExhibitionThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/DDE_Thmbnail.webp";
import DDEExhibition    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/Dde Exhibition Video_LR.mp4";
import LifterThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/Lifter_thumbnail.webp";
import Lifter    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/Lifter V009 Final_LR.mp4";
import MuptForbeshThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/MUPT_Thumbnail.webp";
import MuptForbesh    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/Mupt Forbesh Marshall_LR.mp4";
import PrvControlThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/PRV Control Valve_Hawale_thumbnail.webp";
import PrvControl    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/Prv Control Valve Hawale_LR.mp4";
import packtimeThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/healthcare/20231020_peelpush_03.png";
import packtime    from "../../../../../Assets/Images/gallary/3d animation new/healthcare/Packtime Crsf Av 20231009 V005 Final_lr.mp4";
import rollingMillThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/MonoBlock_Back_V002.png";
import rollingMill    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/Rolling_Mill.mp4";
import FJP   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/FJP.webp";
import FJP_Edit    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/FJP_Edit.mp4";
import EilanThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/20251004_EIlan_Demoreel_MG_00106.png";
import Eilan    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/20251004_EIlan_Demoreel_MG.mp4";
import Packtime_03Thumbnail   from "../../../../../Assets/Images/gallary/3d animation new/healthcare/Packtime_4 machines.webp";
import Packtime_03    from "../../../../../Assets/Images/gallary/3d animation new/healthcare/Packtime_03.mp4";
import ProductPresentationThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/ecommerce/_ProductPresentation_Kordfree_LR (.webp";
import ProductPresentationTrailer    from "../../../../../Assets/Images/gallary/3d animation new/ecommerce/_ProductPresentation_Kordfree_LR.mp4";
import toasterThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/ecommerce/Toster.png";
import toaster    from "../../../../../Assets/Images/gallary/3d animation new/ecommerce/Toster.mp4";
import Drill     from "../../../../../Assets/Images/gallary/3d visualization new/Drill_01.webp";
import drillVideo     from "../../../../../Assets/Images/gallary/3d visualization new/Drill.mp4";
import ExibitionVideoDde    from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/ExibitionVideoDde.mp4";
import ExibitionVideoDdeThumbnail   from "../../../../../Assets/Images/gallary/3d animation new/manufacturing/ExibitionVideoDdeThumbnail.webp";

const ALL_SLIDES_3D = [
  { left: Eilan,                       behind: null, thumb: EilanThumbnail,                  industry: "Manufacturing", sub: "Demo Reel"                     },
    { left: ExibitionVideoDde,          behind: null, thumb: ExibitionVideoDdeThumbnail,      industry: "Manufacturing",    sub: "Industrial Process"              },
  { left: YobykeMaterTrailer,          behind: null, thumb: YobykeMaterTrailerThumbnail,      industry: "Automobile",    sub: "Product Animation"              },
  { left: FJP_Edit,                    behind: null, thumb: FJP,                              industry: "Manufacturing", sub: "Training Video"                 },
  { left: Ape_Teaser_LR,              behind: null, thumb: Ape_Teaser_LR_Banner,             industry: "Automobile",    sub: "Product Animation"              },
  { left: Lifter,                      behind: null, thumb: LifterThumbnail,                  industry: "Manufacturing", sub: "Industrial Process"              },
  { left: DDEExhibition,               behind: null, thumb: DDEExhibitionThumbnail,           industry: "Healthcare",    sub: "Industrial Process Animation"   },
  { left: Billboard,                   behind: null, thumb: BillboardThumbnail,               industry: "Automobile",    sub: "CGI Commercials"                },
  { left: MuptForbesh,                 behind: null, thumb: MuptForbeshThumbnail,             industry: "Manufacturing", sub: "Product Animation"              },
  { left: ProductPresentationTrailer,  behind: null, thumb: ProductPresentationThumbnail,     industry: "E-commerce",    sub: "Product Animation"              },
  { left: PrvControl,                  behind: null, thumb: PrvControlThumbnail,              industry: "Manufacturing", sub: "Product Video"                  },
  { left: rollingMill,                 behind: null, thumb: rollingMillThumbnail,             industry: "Manufacturing", sub: "Industrial Process Animation"   },
  { left: DriftDX_Showcase_Wide,      behind: null, thumb: drift_dx_thumbnail,               industry: "Automobile",    sub: "Product Animation"              },
  { left: packtime,                    behind: null, thumb: packtimeThumbnail,                industry: "Healthcare",    sub: "Product Animation"              },
  // { left: toaster,                  behind: null, thumb: toasterThumbnail,                industry: "E-commerce",    sub: "Product Animation"              },
  { left: drillVideo,                  behind: null, thumb: Drill,                            industry: "E-commerce",    sub: "Product Animation"              },
  { left: Packtime_03,                 behind: null, thumb: Packtime_03Thumbnail,             industry: "Healthcare",    sub: "Product Animation"              },
];

const INDUSTRIES_3D = ["Manufacturing", "Healthcare", "Automobile", "E-commerce"];
const A3D_IMAGE_EXTS = [".png", ".jpg", ".jpeg", ".webp", ".gif", ".avif", ".svg"];

function isImageSrc3D(src) {
  if (!src) return false;
  if (typeof src === "string") {
    const lower = src.toLowerCase();
    return A3D_IMAGE_EXTS.some((ext) => lower.endsWith(ext));
  }
  return false;
}

function VideoPlayer3D({ src, thumb, videoRef: externalRef }) {
  const internalRef = useRef(null);
  const videoRef    = externalRef ?? internalRef;
  const progressRef = useRef(null);
  const wrapRef     = useRef(null);
  const hideTimer   = useRef(null);
  const isDragging  = useRef(false);
  const playerIdRef = useRef(`a3d-${Math.random().toString(36).slice(2)}`);

  const [playing,   setPlaying]   = useState(false);
  const [progress,  setProgress]  = useState(0);
  const [duration,  setDuration]  = useState(0);
  const [showCtrl,  setShowCtrl]  = useState(false);
  const [isFS,      setIsFS]      = useState(false);
  const [showThumb, setShowThumb] = useState(true);
  const [muted,     setMuted]     = useState(false);
  const [volume,    setVolume]    = useState(0.5);

  const isImage = isImageSrc3D(src);

  useVideoCoordinator(playerIdRef.current, videoRef);

  useEffect(() => {
    setShowThumb(true);
    setPlaying(false);
    setProgress(0);
    setDuration(0);
  }, [src]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.volume = 0.5;
      videoRef.current.muted  = false;
    }
  }, []);

  useEffect(() => { return () => clearTimeout(hideTimer.current); }, []);

  useEffect(() => {
    const onChange = () => setIsFS(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const fmt = (s) => {
    if (!s || isNaN(s)) return "0:00";
    return `${Math.floor(s / 60)}:${Math.floor(s % 60).toString().padStart(2, "0")}`;
  };

  const togglePlay = (e) => {
    e.stopPropagation();
    if (isImage) return;
    const v = videoRef.current; if (!v) return;
    if (v.paused) v.play().catch(() => {}); else v.pause();
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    setMuted((prev) => {
      const next = !prev;
      if (videoRef.current) { videoRef.current.muted = next; videoRef.current.volume = volume; }
      return next;
    });
  };

  const handleVolume = (e) => {
    e.stopPropagation();
    const val = parseFloat(e.target.value);
    setVolume(val);
    if (videoRef.current) { videoRef.current.volume = val; videoRef.current.muted = val === 0; }
    setMuted(val === 0);
  };

  const toggleFS = (e) => {
    e.stopPropagation();
    if (!document.fullscreenElement) wrapRef.current?.requestFullscreen().catch(() => {});
    else document.exitFullscreen();
  };

  const seekTo = useCallback((clientX) => {
    const bar = progressRef.current; const v = videoRef.current;
    if (!bar || !v || isNaN(v.duration)) return;
    const rect = bar.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    v.currentTime = ratio * v.duration;
    setProgress(ratio);
  }, []);

  const handleSeekMouseDown = (e) => {
    e.stopPropagation(); if (isImage) return;
    isDragging.current = true; seekTo(e.clientX);
    const onMove = (ev) => { if (isDragging.current) seekTo(ev.clientX); };
    const onUp   = ()   => { isDragging.current = false; window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp); };
    window.addEventListener("mousemove", onMove); window.addEventListener("mouseup", onUp);
  };

  const handleSeekTouchStart = (e) => {
    e.stopPropagation(); if (isImage) return;
    isDragging.current = true; seekTo(e.touches[0].clientX);
    const onMove = (ev) => { if (isDragging.current) seekTo(ev.touches[0].clientX); };
    const onEnd  = ()   => { isDragging.current = false; window.removeEventListener("touchmove", onMove); window.removeEventListener("touchend", onEnd); };
    window.addEventListener("touchmove", onMove, { passive: true }); window.addEventListener("touchend", onEnd);
  };

  const showControls = () => {
    setShowCtrl(true); clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setShowCtrl(false), 2500);
  };

  const effectiveVolume = muted ? 0 : volume;

  const VolumeIcon = () => {
    if (muted || effectiveVolume === 0) return (<svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17.73 18l2 2L21 18.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>);
    if (effectiveVolume < 0.5) return (<svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/></svg>);
    return (<svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>);
  };

  if (isImage) {
    return (
      <div ref={wrapRef} className="a3d-cvid">
        <img src={src} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", background: "#000" }} />
      </div>
    );
  }

  return (
    <div ref={wrapRef} className="a3d-cvid"
      onMouseMove={showControls} onMouseEnter={showControls}
      onMouseLeave={() => { clearTimeout(hideTimer.current); setShowCtrl(false); }}
      onClick={togglePlay}
    >
      <video
        ref={videoRef} src={src} muted={muted} playsInline loop={false}
        onTimeUpdate={() => { const v = videoRef.current; if (v?.duration && !isDragging.current) setProgress(v.currentTime / v.duration); }}
        onLoadedMetadata={() => { if (videoRef.current) { setDuration(videoRef.current.duration); videoRef.current.volume = volume; videoRef.current.muted = muted; } }}
        onPlay={() => { setPlaying(true); setShowThumb(false); notifyPlaying(playerIdRef.current); }}
        onPause={() => setPlaying(false)}
        onEnded={() => { setPlaying(false); setProgress(0); }}
        style={{ width: "100%", height: "100%", objectFit: isFS ? "contain" : "fill", display: "block", background: "#000" }}
      />
      {thumb && (
        <div className={`a3d-cvid-thumb-overlay${showThumb ? " a3d-cvid-thumb-overlay--visible" : ""}`}>
          <img src={thumb} alt="" />
        </div>
      )}
      {!playing && (
        <div className="a3d-cvid-play-overlay" onClick={togglePlay}>
          <svg viewBox="0 0 80 80" fill="none" width="52" height="52">
            <circle cx="40" cy="40" r="40" fill="rgba(0,0,0,0.45)" />
            <polygon points="32,24 60,40 32,56" fill="white" />
          </svg>
        </div>
      )}
      <div className={`a3d-cvid-ctrl${showCtrl ? " a3d-cvid-ctrl--show" : ""}`}>
        <button className="a3d-cvid-playbtn" onClick={togglePlay}>
          {playing ? <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><rect x="5" y="3" width="4" height="18" rx="1"/><rect x="15" y="3" width="4" height="18" rx="1"/></svg>
                   : <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><polygon points="5,3 19,12 5,21"/></svg>}
        </button>
        <span className="a3d-cvid-time">{fmt(progress * duration)}</span>
        <div ref={progressRef} className="a3d-cvid-bar" onMouseDown={handleSeekMouseDown} onTouchStart={handleSeekTouchStart}>
          <div className="a3d-cvid-bar-fill" style={{ width: `${progress * 100}%` }} />
          <div className="a3d-cvid-bar-thumb" style={{ left: `${progress * 100}%` }} />
        </div>
        <span className="a3d-cvid-time">{fmt(duration)}</span>
        <div className="a3d-cvid-vol-group" onClick={(e) => e.stopPropagation()}>
          <button className="a3d-cvid-playbtn" onClick={toggleMute} aria-label={muted ? "Unmute" : "Mute"}><VolumeIcon /></button>
          <input className="a3d-cvid-vol-slider" style={{ "--vol": effectiveVolume }} type="range" min="0" max="1" step="0.02" value={effectiveVolume} onChange={handleVolume} aria-label="Volume" />
        </div>
        <button className="a3d-cvid-playbtn" onClick={toggleFS}>
          {isFS ? <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>
                : <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>}
        </button>
      </div>
    </div>
  );
}

function VideoSlider3D({ slides }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [videoIdx,    setVideoIdx]    = useState(0);
  const mainRefs   = useRef([]);
  const behindRefs = useRef([]);
  if (mainRefs.current.length !== slides.length) {
    mainRefs.current   = slides.map((_, i) => mainRefs.current[i]   ?? React.createRef());
    behindRefs.current = slides.map((_, i) => behindRefs.current[i] ?? React.createRef());
  }
  const pauseOthers = useCallback((keepIdx) => {
    slides.forEach((_, i) => {
      if (i === keepIdx) return;
      [mainRefs.current[i], behindRefs.current[i]].forEach((r) => {
        if (r?.current && r.current.pause) { r.current.pause(); r.current.currentTime = 0; }
      });
    });
  }, [slides]);
  const handleThumbClick = (i) => {
    if (i === activeSlide) return;
    [mainRefs.current[activeSlide], behindRefs.current[activeSlide]].forEach((r) => {
      if (r?.current && r.current.pause) { r.current.pause(); r.current.currentTime = 0; }
    });
    setActiveSlide(i); setVideoIdx(0); pauseOthers(i);
    setTimeout(() => { const v = mainRefs.current[i]?.current; if (v && v.play) { v.currentTime = 0; v.play().catch(() => {}); } }, 50);
  };
  const handleDotClick = (dotIdx) => {
    [mainRefs.current[activeSlide], behindRefs.current[activeSlide]].forEach((r) => {
      if (r?.current && r.current.pause) { r.current.pause(); r.current.currentTime = 0; }
    });
    setVideoIdx(dotIdx);
  };
  const currentSlide = slides[activeSlide];
  const hasBehind    = Boolean(currentSlide?.behind);
  return (
    <div className="a3d-vslider-wrap">
      <div className="a3d-vslider">
        <div className="a3d-vslider-left-wrap">
          <div className="a3d-vslider-left">
            {currentSlide?.sub && <div className="a3d-sub-pill">{currentSlide.sub}</div>}
            <div className={`a3d-vslider-vid-layer${videoIdx === 0 ? " a3d-vslider-vid-layer--active" : ""}`}>
              <VideoPlayer3D src={currentSlide.left} thumb={currentSlide.thumb} videoRef={mainRefs.current[activeSlide]} />
            </div>
            {hasBehind && (
              <div className={`a3d-vslider-vid-layer${videoIdx === 1 ? " a3d-vslider-vid-layer--active" : ""}`}>
                <VideoPlayer3D src={currentSlide.behind} thumb={currentSlide.thumb} videoRef={behindRefs.current[activeSlide]} />
              </div>
            )}
          </div>
          {hasBehind && (
            <div className="a3d-vslider-dots">
              <button className={`a3d-vslider-dot${videoIdx === 0 ? " a3d-vslider-dot--active" : ""}`} onClick={() => handleDotClick(0)} aria-label="Main video" />
              <button className={`a3d-vslider-dot${videoIdx === 1 ? " a3d-vslider-dot--active" : ""}`} onClick={() => handleDotClick(1)} aria-label="Behind the scenes" />
            </div>
          )}
        </div>
        <div className="a3d-thumb-stack">
          {slides.map((slide, i) => (
            <button key={i} className={`a3d-thumb-stack-item${activeSlide === i ? " a3d-thumb-stack-item--active" : ""}`} onClick={() => handleThumbClick(i)}>
              <img src={slide.thumb} alt={slide.sub} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Section3DAnimationNew() {
  const [activeFilter, setActiveFilter] = useState(null);
  const visibleSlides = useMemo(() => {
    if (!activeFilter) return ALL_SLIDES_3D;
    return ALL_SLIDES_3D.filter((s) => s.industry === activeFilter);
  }, [activeFilter]);
  const handleFilter = (industry) => { setActiveFilter((prev) => (prev === industry ? null : industry)); };
  return (
    <section className="g-section g-section--white a3d-section-decor">
      <div className="g-container">
        <div className="a3d-hdr">
          <div className="a3d-hdr-left">
            <h2 className="a3d-title">3D Animation</h2>
            <p className="a3d-desc">Visualizing products, processes, and concepts that are difficult to explain through conventional communication.</p>
          </div>
          <div className="a3d-filter-bar">
            {INDUSTRIES_3D.map((ind) => (
              <button key={ind} className={`a3d-filter-btn${activeFilter === ind ? " a3d-filter-btn--active" : ""}`} onClick={() => handleFilter(ind)}>{ind}</button>
            ))}
            <button className={`a3d-filter-clear${activeFilter ? " a3d-filter-clear--visible" : ""}`} onClick={() => setActiveFilter(null)} aria-label="Clear filter" tabIndex={activeFilter ? 0 : -1}>
              <svg viewBox="0 0 24 24" fill="none" width="13" height="13"><line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/><line x1="20" y1="4" x2="4" y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/></svg>
            </button>
          </div>
        </div>
        <div className="a3d-body">
          {visibleSlides.length > 0 ? <VideoSlider3D key={activeFilter ?? "all"} slides={visibleSlides} /> : <div className="a3d-empty">No videos found for this industry.</div>}
        </div>
        <p className="a3d-bottom-desc">Applied across industries to improve product understanding, stakeholder communication, and decision-making.</p>
      </div>
    </section>
  );
}